<template>
  <svg
    width="71"
    height="52"
    viewBox="0 0 71 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="71" height="52" fill="white" />
    <path
      opacity="0.8"
      d="M35.8184 3.54102C48.3223 3.54102 58.459 13.6777 58.459 26.1816C58.4588 38.6854 48.3222 48.8213 35.8184 48.8213C23.3146 48.8213 13.1779 38.6854 13.1777 26.1816C13.1777 13.6778 23.3145 3.54103 35.8184 3.54102ZM66.6094 19.1172C67.7096 19.1173 68.6016 20.0101 68.6016 21.1104C68.6014 22.2105 67.7095 23.1024 66.6094 23.1025C65.5092 23.1025 64.6174 22.2105 64.6172 21.1104C64.6172 20.01 65.509 19.1172 66.6094 19.1172ZM12.2725 1.36719C14.373 1.36719 16.076 3.07038 16.0762 5.1709C16.0762 7.27155 14.3731 8.97461 12.2725 8.97461C10.1718 8.97461 8.46875 7.27155 8.46875 5.1709C8.46891 3.07038 10.1719 1.36719 12.2725 1.36719Z"
      fill="url(#paint0_radial_410_32623)"
    />
    <path
      d="M21.4526 18.9858C21.1271 18.1911 21.5087 17.2826 22.3048 16.9565L39.9632 9.72426C40.7594 9.3982 41.6686 9.77809 41.9941 10.5728L50.9811 32.5159C51.3066 33.3106 50.9251 34.2191 50.1289 34.5452L32.4705 41.7774C31.6744 42.1035 30.7651 41.7236 30.4397 40.9289L21.4526 18.9858Z"
      fill="url(#paint1_radial_410_32623)"
    />
    <path
      d="M25.4297 13.2776C25.4297 12.4188 26.1271 11.7227 26.9874 11.7227H46.0695C46.9298 11.7227 47.6272 12.4188 47.6272 13.2776V36.9898C47.6272 37.8485 46.9298 38.5447 46.0695 38.5447H26.9874C26.1271 38.5447 25.4297 37.8485 25.4297 36.9898V13.2776Z"
      fill="url(#paint2_radial_410_32623)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28.4205 32.5837H30.7317C30.6384 32.4814 30.5816 32.3464 30.5816 32.1983V28.5373H28.4205L28.4205 32.5837ZM27.6347 27.3811H27.2417C26.9162 27.3811 26.6523 27.6399 26.6523 27.9592C26.6523 28.2785 26.9162 28.5373 27.2417 28.5373H27.6347L27.6347 32.5837C27.6347 33.0094 27.9865 33.3544 28.4205 33.3544L44.5307 33.3544C44.9647 33.3544 45.3165 33.0094 45.3165 32.5837V28.5373H46.1024C46.4279 28.5373 46.6918 28.2785 46.6918 27.9592C46.6918 27.6399 46.4279 27.3811 46.1024 27.3811H45.3165V24.8762C45.3165 24.4505 44.9647 24.1055 44.5307 24.1055L28.4205 24.1055C27.9865 24.1055 27.6347 24.4505 27.6347 24.8762V27.3811ZM28.4205 27.3811V24.8762L30.5816 24.8762V27.3811H28.4205ZM31.7604 28.5373V32.1983C31.7604 32.3464 31.7037 32.4814 31.6104 32.5837L35.8398 32.5837C35.7465 32.4814 35.6897 32.3464 35.6897 32.1983V28.5373H31.7604ZM35.6897 27.3811H31.7604V24.8762L35.6897 24.8762V27.3811ZM36.8685 28.5373V32.1983C36.8685 32.3464 36.8118 32.4814 36.7184 32.5837H40.555C40.4616 32.4814 40.4049 32.3464 40.4049 32.1983V28.5373H36.8685ZM40.4049 27.3811H36.8685V24.8762L40.4049 24.8762V27.3811ZM41.5837 28.5373V32.1983C41.5837 32.3464 41.5269 32.4814 41.4336 32.5837H44.5307V28.5373H41.5837ZM44.5307 27.3811H41.5837V24.8762L44.5307 24.8762V27.3811Z"
      fill="#DCE2EE"
    />
    <rect
      x="27.2773"
      y="15.7305"
      width="9.24897"
      height="1.54149"
      rx="0.616598"
      fill="url(#paint3_radial_410_32623)"
    />
    <rect
      x="27.2773"
      y="18.1973"
      width="4.62448"
      height="1.54149"
      rx="0.616598"
      fill="url(#paint4_radial_410_32623)"
    />
    <g opacity="0.75" filter="url(#filter0_f_410_32623)">
      <path
        d="M42.5032 17.3223C48.1731 17.3223 52.7696 21.919 52.7698 27.5889C52.7698 33.2589 48.1732 37.8555 42.5032 37.8555C40.7644 37.8554 39.1279 37.4211 37.6926 36.6582L32.9221 41.4307C31.7694 42.5833 29.9 42.5833 28.7473 41.4307C27.5946 40.278 27.5947 38.4086 28.7473 37.2559L33.4915 32.5107C32.6918 31.0495 32.2366 29.3721 32.2366 27.5889C32.2368 21.9191 36.8334 17.3225 42.5032 17.3223Z"
        fill="url(#paint5_radial_410_32623)"
      />
    </g>
    <path
      d="M33.1892 41.0511C32.0988 42.1415 30.3309 42.1415 29.2405 41.0511C28.1501 39.9607 28.1501 38.1928 29.2405 37.1024L34.8765 31.4664L38.8252 35.415L33.1892 41.0511Z"
      fill="url(#paint6_linear_410_32623)"
    />
    <path
      d="M42.25 18.248C47.6135 18.248 51.9619 22.5965 51.9619 27.96C51.9618 33.3233 47.6134 37.6709 42.25 37.6709C36.8866 37.6709 32.5392 33.3233 32.5391 27.96C32.5391 22.5965 36.8865 18.2481 42.25 18.248ZM42.25 21.1768C38.5043 21.1769 35.468 24.2133 35.4678 27.959C35.4678 31.7048 38.5042 34.742 42.25 34.7422C45.9959 34.7422 49.0332 31.7049 49.0332 27.959C49.033 24.2132 45.9958 21.1768 42.25 21.1768Z"
      fill="#A3B1D1"
    />
    <mask
      id="mask0_410_32623"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="35"
      y="21"
      width="15"
      height="14"
    >
      <circle
        cx="42.2474"
        cy="27.9584"
        r="6.78258"
        fill="url(#paint7_radial_410_32623)"
      />
    </mask>
    <g mask="url(#mask0_410_32623)">
      <path
        d="M16.4727 6.9708C16.4727 5.70653 17.4994 4.68164 18.766 4.68164H46.859C48.1256 4.68164 49.1523 5.70653 49.1523 6.9708V41.8804C49.1523 43.1447 48.1256 44.1696 46.859 44.1696H18.766C17.4994 44.1696 16.4727 43.1447 16.4727 41.8804V6.9708Z"
        fill="url(#paint8_radial_410_32623)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.8805 35.3939H24.2831C24.1457 35.2434 24.0621 35.0445 24.0621 34.8266V29.4367H20.8805L20.8805 35.3939ZM19.7235 27.7346H19.1451C18.6658 27.7346 18.2773 28.1157 18.2773 28.5857C18.2773 29.0557 18.6658 29.4367 19.1451 29.4367H19.7235L19.7235 35.3939C19.7235 36.0206 20.2415 36.5286 20.8805 36.5286L44.5982 36.5286C45.2372 36.5286 45.7552 36.0206 45.7552 35.3939V29.4367H46.9121C47.3913 29.4367 47.7798 29.0557 47.7798 28.5857C47.7798 28.1157 47.3913 27.7346 46.9121 27.7346H45.7552V24.0468C45.7552 23.4201 45.2372 22.9121 44.5982 22.9121L20.8805 22.9121C20.2415 22.9121 19.7235 23.4201 19.7235 24.0468V27.7346ZM20.8805 27.7346V24.0468L24.0621 24.0468V27.7346H20.8805ZM25.7976 29.4367V34.8266C25.7976 35.0445 25.714 35.2434 25.5766 35.3939L31.8033 35.3939C31.6659 35.2434 31.5824 35.0445 31.5824 34.8266V29.4367H25.7976ZM31.5824 27.7346H25.7976V24.0468L31.5824 24.0468V27.7346ZM33.3178 29.4367V34.8266C33.3178 35.0445 33.2343 35.2434 33.0969 35.3939H38.7451C38.6077 35.2434 38.5242 35.0445 38.5242 34.8266V29.4367H33.3178ZM38.5242 27.7346H33.3178V24.0468L38.5242 24.0468V27.7346ZM40.2596 29.4367V34.8266C40.2596 35.0445 40.176 35.2434 40.0386 35.3939H44.5982V29.4367H40.2596ZM44.5982 27.7346H40.2596V24.0468L44.5982 24.0468V27.7346Z"
        fill="#DCE2EE"
      />
      <circle
        cx="41.9075"
        cy="27.6497"
        r="4.77863"
        fill="url(#paint9_linear_410_32623)"
      />
      <path
        d="M45.2171 31.9025C46.1638 31.3631 46.6411 30.6414 46.8526 29.8741C47.0224 29.2582 46.4782 28.7298 45.8393 28.7298L45.6038 28.7298C44.9655 28.7298 44.3872 29.3597 44.2129 29.9738C44.1879 30.062 44.1605 30.1494 44.131 30.2346C43.9601 30.7287 44.0125 31.4738 44.4131 31.8098C44.6402 32.0002 44.9596 32.0492 45.2171 31.9025Z"
        fill="url(#paint10_linear_410_32623)"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_410_32623"
        x="21.7168"
        y="11.1563"
        width="37.2187"
        height="37.3046"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="3.08299"
          result="effect1_foregroundBlur_410_32623"
        />
      </filter>
      <radialGradient
        id="paint0_radial_410_32623"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(58.3661 -11.1502) rotate(118.497) scale(74.1913 80.1999)"
      >
        <stop stop-color="#EAEEF9" />
        <stop offset="1" stop-color="#A3B1D1" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_410_32623"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(37.2452 28.8359) rotate(-112.272) scale(17.5208 23.8433)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_410_32623"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(53.0224 44.8648) rotate(-129.519) scale(43.3623 47.4843)"
      >
        <stop stop-color="#EDF0F6" />
        <stop offset="1" stop-color="#FAFBFD" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_410_32623"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(28.1871 16.423) rotate(4.3184) scale(12.1643 2.47271)"
      >
        <stop stop-color="#D5DDEA" />
        <stop offset="1" stop-color="#DFE4EC" />
      </radialGradient>
      <radialGradient
        id="paint4_radial_410_32623"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(27.7322 18.8898) rotate(8.58828) scale(6.13367 2.45195)"
      >
        <stop stop-color="#D5DDEA" />
        <stop offset="1" stop-color="#DFE4EC" />
      </radialGradient>
      <radialGradient
        id="paint5_radial_410_32623"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(40.4879 26.2061) rotate(89.2327) scale(48.2731 47.4428)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="0.99407" stop-color="white" />
      </radialGradient>
      <linearGradient
        id="paint6_linear_410_32623"
        x1="34.0092"
        y1="36.2824"
        x2="36.8509"
        y2="33.4407"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="1" stop-color="#94A3C6" />
      </linearGradient>
      <radialGradient
        id="paint7_radial_410_32623"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(46.721 17.5976) rotate(113.191) scale(20.2772 18.9227)"
      >
        <stop stop-color="#EAEEF9" />
        <stop offset="1" stop-color="#A3B1D1" />
      </radialGradient>
      <radialGradient
        id="paint8_radial_410_32623"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(57.0953 53.4742) rotate(-129.519) scale(63.839 69.9074)"
      >
        <stop stop-color="#EDF0F6" />
        <stop offset="1" stop-color="#FAFBFD" />
      </radialGradient>
      <linearGradient
        id="paint9_linear_410_32623"
        x1="38.1426"
        y1="23.5951"
        x2="41.7627"
        y2="27.3601"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_410_32623"
        x1="46.1981"
        y1="31.1791"
        x2="44.8457"
        y2="30.1827"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>
</template>
